module.exports = __webpack_public_path__ + "static/media/event-3.90b057f2.jpg";